import { Edge, Node } from "@xyflow/react";
import { atom } from "jotai";
import { uuid } from "../utils";
import { nodesAtom } from "../nodes";
import { edgesAtom } from "../edges";
import { zslAtom } from "../templates";
import { saveCanvasSetter } from "../persistence";
import { isViewOnlyModeAtom } from "../permissions";

const defaultNode = {
  id: uuid(),
  type: "default",
  data: {
    label: "",
    services: [],
  },
  position: { x: 0, y: 0 },
};

function getDefaultState() {
  const nodes: Node[] = [defaultNode];

  const edges: Edge[] = [];

  return { nodes, edges };
}

type Params = (node: Node) => void;

export const clearCanvasSetter = atom(
  null,
  (_get, set, centerAndZoomOnNode: Params) => {
    const { nodes, edges } = getDefaultState();
    set(nodesAtom, nodes);
    set(edgesAtom, edges);
    set(zslAtom, undefined); // Remove draft mode / template banner
    set(isViewOnlyModeAtom, false);

    centerAndZoomOnNode(nodes[0]);

    set(saveCanvasSetter, { nodes, edges });
  },
);

clearCanvasSetter.debugLabel = "clearCanvasSetter";
